(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-validate/assets/javascript/components/speech-bubble-tur-slim.js') >= 0) return;  svs.modules.push('/modules/tickets-validate/assets/javascript/components/speech-bubble-tur-slim.js');
"use strict";


const SpeechBubbleTurSlim = _ref => {
  let children = _ref.children;
  return React.createElement(React.Fragment, null, React.createElement("svg", {
    className: "speech-bubble-svg",
    viewBox: "0 0 120 36",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    className: "speech-bubble-svg-path",
    d: "M14.6913 0H119.908V29.3222H21.7952V35.6703L7.34568 27.3573C2.93224 24.8181 1.52588e-05 20.0721 1.52588e-05 14.6611C-0.0302124 6.55971 6.55972 0 14.6913 0Z"
  })), React.createElement("span", {
    className: "speech-bubble-content speech-bubble-content-slim"
  }, children));
};
setGlobal('svs.ticketsValidate.components.SpeechBubbleTurSlim', SpeechBubbleTurSlim);

 })(window);